const LUMINA_EVENT_CONFIG = {
  hyd: {
    city: "Hyderabad",
    date: "26th September 2026",
    time: "3:00 PM Onwards",
    venue: "Anvaya Conventions",
    address:
      "Sy No. 235, 236, VN Pally, Financial District, Gowlidoddy, Gachibowli, Hyderabad, Telangana 500032"
  },

  chn: {
    city: "Chennai",
    date: "09th October 2026",
    time: "4:00 PM Onwards",
    venue: "Taj Coromandel",
    address:
      "37, Uthamar Gandhi Rd (formerly Mahatma Gandhi Road), Tirumurthy Nagar, Nungambakkam, Chennai, Tamil Nadu 600034"
  },

  blr: {
    city: "Bengaluru",
    date: "11th October 2026",
    time: "4:00 PM Onwards",
    venue: "Conrad",
    address:
      "25/3, Kensington Road, Ulsoor (Halasuru), Bengaluru, Karnataka 560008, India"
  }
};

export default LUMINA_EVENT_CONFIG;
